module.exports = __webpack_public_path__ + "static/img/xls-icon.ba8084ea.svg";